import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ApplicationDecisionService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/checklistDecisionStatus`, options);
  }
}

export default ApplicationDecisionService;
